import { FC, useState } from "react";
import styles from './EntranceItem.module.less';
import Arrow from './Arrow';

const EntranceItem: FC = (props) => {
    const [color, setColor] = useState(props.backgroundColor);
    const [size, setSize] = useState(20);
    return (
        <div onMouseOver={() => {setColor(props.hoverColor); setSize(25)}} onMouseOut={() => {setColor(props.backgroundColor); setSize(20)}} onClick={props.onClick} style={{backgroundColor: color}} className={styles.body}>
            <div className={styles.image}>
                <img style={{width: '53px', height: '53px'}} src={props.icon} alt="" />
            </div>
            <div  className={styles.text} style={{color: props.textColor}}>{props.text}</div>
            <div className={styles.arrow}>
                <Arrow size={size} color={props.textColor}></Arrow>
            </div>
        </div>
    );
}

export default EntranceItem;